<script>
import PoliceInformation from '../components/PoliceInformation.vue';
import AddressSearch from '@/components/UI/AddressSearch.vue';
import BaseMixin from '@/components/Feature/BaseMixin.vue';
import CprNumberField from '@/components/UI/CprNumberField.vue';
import Questionnaire from '@/components/UI/QuestionnaireQQ.vue';
import Utility from '@/common/UtilityFunctions.js';
import DatePicker from '@/components/UI/Pickadate.vue';
import vSelect from 'vue-select';
import { flatMap, sortBy } from 'lodash';
import moment from 'moment';
import ReportClaimServicesMixin from './ReportClaimServicesMixin.vue';

export default {
  components: {
    Questionnaire,
    PoliceInformation,
    CprNumberField,
    AddressSearch,
    DatePicker,
    vSelect
  },
  mixins: [BaseMixin, ReportClaimServicesMixin],
  props: {
    index: {
      type: Number,
      default() {
        return 1;
      }
    },
    errors: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  data() {
    return {
      saving: false,
      chosenAnswers: [],
      defaultCountryCode: this.vueModel.CreateClaimStep1Model.DefaultCountry.Id,
      questions: []
    };
  },
  computed: {
    title() {
      var title = '';

      for (var i in this.$parent.pills) {
        if (this.$parent.pills[i].name === this.name) {
          title = this.$parent.pills[i].title;
        }
      }

      return title;
    },
    claimEventDate() {
      return moment(this.vueModel.CreateClaimEntity.ClaimEventDate).format();
    },
    hasQuestionnaireQuestions() {
      return this.questions.filter((obj) => obj.IsActivated && obj.IsVisibleForPortal).length > 0;
    }
  },
  watch: {
    'stepModel.ProductSpecific.PoliceReportFiled': function (val) {
      if (this.vueModel.CreateClaimEntity.ProductSpecific.IsPoliceReportFiled !== undefined) {
        this.vueModel.CreateClaimEntity.ProductSpecific.IsPoliceReportFiled = val;
      }

      return val ? Utility.nextTickScroll('#police-report-filed', this) : null;
    }
  },
  mounted() {
    this.scrollToTop();

    if (this.index > 1) {
      this.$emit('show-back-button', true);
    } else {
      this.$emit('show-back-button', false);
    }

    // Reset for IE
    // TODO: REFACTOR LEGACY VALIDATOR
    // this.$validator.reset();

    this.$emit('component-mounted', true);
    this.questions = this.sortQuestions();

    this.dispatchEventInMounted();
  },
  methods: {
    dispatchEventInMounted() {
      this.dispatchEventWithCloseFormAction(false);
    },
    sortQuestions() {
      if (this?.vueModel?.CreateClaimEntity?.ProductSpecific === null) {
        return [];
      }

      const preSortedQuestionnaires =
        this?.vueModel?.CreateClaimEntity?.ProductSpecific?.QuestionnaireList;
      if (preSortedQuestionnaires === null) {
        return [];
      }

      for (
        var questionnaireIndex = 0;
        questionnaireIndex < preSortedQuestionnaires.length;
        questionnaireIndex++
      ) {
        if (preSortedQuestionnaires[questionnaireIndex].Questions) {
          for (
            var questionIndex = 0;
            questionIndex < preSortedQuestionnaires[questionnaireIndex].Questions.length;
            questionIndex++
          ) {
            let question = preSortedQuestionnaires[questionnaireIndex].Questions[questionIndex];

            question.Sortorder += questionnaireIndex * 1000;
          }
        }
      }

      const flattened = flatMap(preSortedQuestionnaires, this.selectQuestions);
      return sortBy(flattened, 'Sortorder');
    },
    selectQuestions(questionnaireModel) {
      return questionnaireModel.Questions;
    },
    updateAddress(prop, selectedProp) {
      if (selectedProp === null) {
        this.resetAddressProp(prop);
      } else {
        this.updateAddressProp(prop, selectedProp);
      }
    },
    updateAddressProp(prop, selectedProp) {
      if (!selectedProp.adresse) {
        return;
      }

      prop.Street = selectedProp.adresse.vejnavn;
      prop.HouseNumber = selectedProp.adresse.husnr;
      prop.Floor = selectedProp.adresse.etage;
      prop.Designation = selectedProp.adresse.dør;
      prop.District = selectedProp.adresse.supplerendebynavn;
      prop.PostalCode = selectedProp.adresse.postnr;
      prop.City = selectedProp.adresse.postnrnavn;
      prop.CountryRef = this.defaultCountryCode;
    },
    resetAddressProp(prop, countryCode = this.defaultCountryCode) {
      prop.Street = null;
      prop.HouseNumber = null;
      prop.Floor = null;
      prop.Designation = null;
      prop.District = null;
      prop.PostalCode = null;
      prop.City = null;
      prop.CountryRef = countryCode;
    },
    showErrorMessage(field) {
      var error = this.errors.items.find((x) => x.field === field);

      if (!error) {
        return true;
      }

      if (error.rule === 'required') {
        return false;
      }

      return true;
    }
  }
};
</script>
